import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Header from "./Header";
import AudioPlayer from "./AudioPlayer";
import { usePlayer } from "../context/PlayerContext";
import { useAuth } from "../context/AuthContext";

export function Layout({ children }) {
  const { current } = usePlayer();
  return (
    <div className="App grain min-h-screen">
      <Header />
      <main className={`relative z-10 ${current ? "pb-28" : "pb-12"}`}>{children}</main>
      <AudioPlayer />
    </div>
  );
}

export function Loading() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <Loader2 className="animate-spin text-primary" size={28} />
    </div>
  );
}

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/auth" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
